// extracted by mini-css-extract-plugin
export default {"btn":"BidsListButton_btn__pDHFb","modal":"BidsListButton_modal__4KdC4"};